import withAemIntegration from "../../withAemIntegration";

const VehicleSelectorModelEditConfig = {
  emptyLabel: "VehicleSelectorModel",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const VehicleSelectorModel = (props) => {
  return (
    <ul>
      <li>Tagline: {props.tagline}</li>
      <li>Name: {props.name}</li>
      <li>Year: {props.modelYear}</li>
      <li>Model Key: {props.modelKey}</li>
    </ul>
  );
};

export default withAemIntegration("lexus/components/vehicle-selector-model")(
  VehicleSelectorModel,
  VehicleSelectorModelEditConfig
);
